import { UrlMappingsKeys } from '@wix/url-mapper-utils';
import { encodeURIComponentIfNeeded } from '../../../common/services/uri';
import type { IWixCodeApi } from '../../../common/controller/wix-code-api';

export const customRouteHandler = async (wixCodeApi: IWixCodeApi) => {
  const path = `/${wixCodeApi.location.path
    .map(encodeURIComponentIfNeeded)
    .join('/')}`;
  const { key, segments } =
    (await wixCodeApi?.site?.getCustomizedUrlSegments?.(path)) || {};

  if (!key) {
    return null;
  }

  const slug = encodeURIComponentIfNeeded(segments?.slug);
  const instance = encodeURIComponentIfNeeded(segments?.instance);

  return (
    {
      [UrlMappingsKeys.BLOG_POST]: `/${slug}`,
      [UrlMappingsKeys.BLOG_POST_EDIT]: `/${slug}/edit`,
      [UrlMappingsKeys.BLOG_POST_PREVIEW]: `/${slug}/preview/${instance}`,
    }[key] || null
  );
};
